// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__Gg8vP","title":"ErrorMessage_title__YpHA5","childrenContainer":"ErrorMessage_childrenContainer__itLsw"};